import React from 'react';
import Loginheader from './Loginheader';
import Menu from './Menu';


function Home(){
    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <div>
                <h1>I am home page....</h1>
            </div>
        </>
    );
}
export default Home;